import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class WoodenBridgeTileEntity extends TileEntity {
	public static readonly frameName = FrameName.WOODEN_BRIDGE;
}

export default WoodenBridgeTileEntity;
